import { render } from "./App.vue?vue&type=template&id=316b806f"
const script = {}

import "./App.vue?vue&type=style&index=0&id=316b806f&lang=scss"
script.render = render

export default script